import { StyledSpinner } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledConfirmMessage = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledLoadingSpinner = styled(StyledSpinner)`
  margin-right: 0.5rem;
`;
